import { formatDate, formatDateISO } from '@helpers/date';
import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import React from 'react';
import S from './EventDetailHero.styles';
const EventDetailHero = ({ breadcrumb, date, location, tag, time, title, }) => {
    return (React.createElement(S.Container, { flush: "both" },
        React.createElement(S.Inner, null,
            breadcrumb?.length && (React.createElement(S.BreadcrumbWrapper, null,
                React.createElement(Breadcrumb, { items: breadcrumb }))),
            React.createElement(S.ContentWrapper, null,
                tag && React.createElement(S.Tag, null, tag),
                React.createElement(S.Title, null, title)),
            React.createElement(S.Base, null,
                date && (React.createElement(S.Date, { as: "time", dateTime: formatDateISO(date) },
                    React.createElement(S.DateSvg, null),
                    formatDate(date))),
                time && (React.createElement(S.Time, null,
                    React.createElement(S.TimeSvg, null),
                    time)),
                location && (React.createElement(S.Location, null,
                    React.createElement(S.LocationSvg, null),
                    location))))));
};
export default EventDetailHero;
